import MAV from '@/api/mav';
import { isAppShadowMode } from '@/helpers/mavModeDetection';

/**
 * Fire-and-forget shadow evaluation for a batch of iOS UA discoveries.
 * @param {Object} params
 * @param {Array<Object>} params.discoveries - Discovery objects with domain, user_agent, app_name, countries
 * @param {number} params.expectedApplicationId - The selected app dictionary ID
 * @param {string} params.expectedApplicationName - The selected application name
 */
export function sendIosAppBulkShadowEvaluation({
  discoveries,
  expectedApplicationId,
  expectedApplicationName,
}) {
  if (!isAppShadowMode() || !discoveries?.length || expectedApplicationId == null) {
    return Promise.resolve();
  }

  const payload = {
    discoveries: discoveries.map(d => ({
      domain: d.domain || '',
      user_agent: d.user_agent || '',
      app_name: d.app_name || '',
      countries: d.countries || [],
    })),
    expected_application_id: expectedApplicationId,
    expected_application_name: expectedApplicationName || '',
  };

  return MAV.post('/shadow/app/ios/ua/batch', payload).catch(error => {
    console.error('[iOS App Shadow API] Bulk evaluation failed:', error);
  });
}
